import './css/auxiliary.less'
import './css/tw.css'
import './css/editor.less'
import './posthog'
import { createHead } from '@vueuse/head'

import { createApp } from 'vue'
import App from './App.vue'

import { OhVueIcon } from "oh-vue-icons";
import "./icons";


const app = createApp(App);
const head = createHead()

app.use(head)
app.component("v-icon", OhVueIcon);
app.mount('#app');
